import type { RootState } from "@/data/store";
import { preparationEndDatePassed } from "@/features/socratic/socratic-slice/socratic-slice";

import { createDateListener } from "../timeline-listeners/create-date-listener";

/**
 * Listener for the preparation end date in Socratic dialogue.
 *
 * Monitors when the preparation time ends and dispatches the action
 * to automatically start recording if the student hasn't started early.
 */
export const preparationEndDateListener = createDateListener(
  (state: RootState) => state.socratic.dialogueTimeline.preparationEndDate,
  (listenerApi) => {
    listenerApi.dispatch(preparationEndDatePassed());
  }
);
